const apiOrigin = import.meta.env.VITE_API_ORIGIN?.replace(/\/$/, "") || "";

export class ApiError extends Error {
  constructor(message: string, public readonly status = 0) {
    super(message);
  }
}

export async function apiFetch<T>(
  path: string,
  init: RequestInit = {},
  timeoutMs = 15000,
): Promise<T> {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetch(`${apiOrigin}${path}`, {
      ...init,
      signal: controller.signal,
      headers: { ...init.headers },
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) throw new ApiError(body.error || "request-failed", response.status);
    return body as T;
  } catch (caught) {
    if (caught instanceof DOMException && caught.name === "AbortError") {
      throw new ApiError("network-timeout");
    }
    throw caught;
  } finally {
    window.clearTimeout(timeout);
  }
}

export function apiUrl(path: string) {
  return `${apiOrigin}${path}`;
}
